import { gql, useQuery } from '@apollo/client';
import { fetchApi } from '../api/fetchApi';
const GRAPHQL_ENDPOINT = '/api/graphql';
const RETAILER_NUORDER_ACCOUNT_QUERY = `
  query GetRetailerNuorderAccount {
    retailerNuorderAccount {
      account {
        nuorderUser {
          id
          email
          fullname
          merchantID
        }
      }
    }
  }
`;
export const GET_RETAILER_NUORDER_ACCOUNT = gql(RETAILER_NUORDER_ACCOUNT_QUERY);
/**
 * Fetches the retailer NuOrder account details via the internal GraphQL endpoint.
 * Returns `null` when no NuOrder account is linked.
 */
export async function fetchRetailerNuorderAccount() {
    var _a, _b, _c;
    const response = await fetchApi(GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ query: RETAILER_NUORDER_ACCOUNT_QUERY }),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch retailer nuorder account request');
    }
    const payload = await response.json();
    if (payload.errors || ((_a = payload.data) === null || _a === void 0 ? void 0 : _a.retailerNuorderAccount) === undefined) {
        throw new Error('Failed to fetch retailer nuorder account request');
    }
    return (_c = (_b = payload.data) === null || _b === void 0 ? void 0 : _b.retailerNuorderAccount) !== null && _c !== void 0 ? _c : null;
}
export const useRetailerNuorderAccount = () => {
    var _a, _b, _c;
    const { data, loading, error } = useQuery(GET_RETAILER_NUORDER_ACCOUNT);
    const hasNuorder = !!((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.retailerNuorderAccount) === null || _a === void 0 ? void 0 : _a.account) === null || _b === void 0 ? void 0 : _b.nuorderUser) === null || _c === void 0 ? void 0 : _c.id);
    return {
        hasNuorder,
        isLoading: loading,
        error,
        data,
    };
};
